import PropTypes from 'prop-types';
import { Paginator as PaginatorFromCodex } from '@codex/basics';
import { connect } from 'react-redux';

import { createListingPageUrlFromAttributes } from '../../listingPageUrlParser/listingPageUrlParser';
import { changePageNumber } from '../../reduck/listingPagePages.reduck';
import { getActiveListingPage } from '../../reduck/selectors';


function Paginator({ pagesList, onLinkClick }) {

  return (
    <PaginatorFromCodex
      pagesList={pagesList}
      onLinkClick={onLinkClick}
    />
  );
}

Paginator.propTypes = {
  pagesList: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string.isRequired,
    label: PropTypes.number.isRequired,
    isCurrent: PropTypes.bool.isRequired
  })).isRequired,
  onLinkClick: PropTypes.func
};

Paginator.defaultProps = {
  onLinkClick: () => {}
};

const mapStateToProps = (state) => {
  const listingPageData = getActiveListingPage(state);
  let pagesList = [];

  if (listingPageData) {
    const currentPageDataIndex = listingPageData.pagination.findIndex((page) => page.selected);

    let startIndex = currentPageDataIndex - 2; // slice start index is inclusive
    let endIndex = currentPageDataIndex + 3; // slice end index is exclusive (1 more)

    if (startIndex < 0) {
      endIndex += Math.abs(startIndex);
      startIndex = 0;
    }

    let additionalStart = listingPageData.pagination.length - (currentPageDataIndex + 3);
    if (additionalStart < 0) {
      additionalStart = Math.abs(additionalStart);
      // Start index can not be less than 0 after applying additionalStart
      startIndex = (startIndex - additionalStart < 0) ? 0 : (startIndex - additionalStart);
    }

    const pagesToBeShownFromRedux =
      listingPageData.pagination.slice(
        startIndex,
        endIndex
      );

    pagesList = pagesToBeShownFromRedux.map((pageData) => (
      {
        label: Number(pageData.page),
        isCurrent: state.listingPage.commonData.xhrStatus.pendingProductsRequest
          ? true : pageData.selected,
        searchLabsPageRequestAttrs: { ...listingPageData.pageAttributes, page: pageData.page },
        url: listingPageData.pageUrlPrefix +
          createListingPageUrlFromAttributes({ ...listingPageData.pageAttributes, page: pageData.page })
      }
    ));
  }

  return {
    pagesList
  };
};

const mapDispatchToProps = (dispatch) => ({
  onLinkClick: (url, pageNumber) => {
    dispatch(changePageNumber(String(pageNumber)));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Paginator);
